import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CallerContextModule } from '../../../features/caller-context/caller-context.module';
import { SearchComponent } from '../search/search.component';

@Component({
  selector: 'app-global-search-bar',
  templateUrl: './global-search-bar.component.html',
  styleUrls: ['./global-search-bar.component.scss'],
  imports: [CommonModule, CallerContextModule, SearchComponent],
})
export class GlobalSearchBarComponent {
  @Input() fixedToTop = false;
}
